import React, { useState, useEffect, useRef } from 'react';
import styles from './HomePage3.module.scss';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, LineElement, PointElement, LinearScale, Tooltip, Filler, CategoryScale } from 'chart.js';
import { Modal } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import logo from '../images/logo.png';
import phoneMock from '../images/phone-mock.png';
import laptopMock from '../images/laptop-mock.png';
import bitcoinCard from '../images/bitcoin-card.png';
import chartCard from '../images/chart-card.png';
import btcIcon from '../images/icons/bitcoin-icon.svg';
import ethIcon from '../images/icons/eth-ic.svg';
import bnbIcon from '../images/icons/bsh.svg';
import usdtIcon from '../images/icons/teher.svg';
import coinsIcon from '../images/icons/coins-dollar.svg';
import worldIcon from '../images/icons/world-icon.svg';
import notificationIcon from '../images/icons/notification-icon.svg';
import sunIcon from '../images/icons/sun-icon.svg';
import chartBarIcon from '../images/icons/chart-bar-icon.svg';
import IconDollar from '../images/icons/Icon$.svg';
import linkedinIcon from '../images/linkedin.svg';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import Skeleton from './Skeleton';
import introLaptopImg from '../images/Group 2085664280.png';
import chartImg from '../images/Chart.png';
import { useNavigate } from 'react-router-dom';
import SignIn from './SignIn';
import { useMediaQuery } from 'react-responsive';

ChartJS.register(LineElement, PointElement, LinearScale, Tooltip, Filler, CategoryScale);

// Google Fonts
const fontLink = document.createElement('link');
fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap';
fontLink.rel = 'stylesheet';
document.head.appendChild(fontLink);

const advantages = [
  { icon: coinsIcon, text: 'One-Click Trading – Instant order execution' },
  { icon: worldIcon, text: 'Real-Time Market Data – 99.9% uptime' },
  { icon: notificationIcon, text: 'Negative Balance Protection' },
  { icon: sunIcon, text: 'No Hidden Fees' },
  { icon: chartBarIcon, text: 'Regulated Platform' },
  { icon: IconDollar, text: 'Mandatory 2FA for security' },
];

const chartData = {
  labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  datasets: [
    {
      label: 'Profit ($)',
      data: [120, 150, 180, 170, 210, 250, 230],
      borderColor: '#3a6df0',
      backgroundColor: 'rgba(58,109,240,0.08)',
      tension: 0.4,
      fill: true,
      pointRadius: 4,
      pointBackgroundColor: '#3a6df0',
    },
  ],
};

const chartOptions = {
  plugins: {
    legend: { display: false },
  },
  scales: {
    x: { display: false },
    y: { display: false },
  },
  responsive: true,
  maintainAspectRatio: false,
};

const educationList = [
  'Free tiered courses from basics to advanced algo-trading',
  'Daily expert webinars (20+ monthly sessions)',
  'Proven strategy blueprints with backtested results',
  'Dedicated onboarding & mentor',
];

const educationStats = [
  { label: 'Increase in Trade', value: '+75%' },
  { label: 'Price in dollar', value: '$15.32' },
];

// Мапа symbol → CoinMarketCap ID
const coinmarketcapIdMap = {
  BTC: 1,
  ETH: 1027,
  USDT: 825,
  BNB: 1839,
  SOL: 5426,
  XRP: 52,
  DOGE: 74,
  ADA: 2010,
  TRX: 1958,
  TON: 11419,
  SHIB: 5994,
  AVAX: 5805,
  LINK: 1975,
  MATIC: 3890,
  DOT: 6636,
  BCH: 1831,
  XLM: 512,
  FIL: 2280,
  LTC: 2,
};

function getCryptoIcon(symbol, cgIcon) {
  const id = coinmarketcapIdMap[symbol];
  if (id) {
    return `https://s2.coinmarketcap.com/static/img/coins/64x64/${id}.png`;
  }
  if (cgIcon) return cgIcon;
  return coinsIcon;
}

const mockChartData = [
  [1560, 1570, 1565, 1572, 1568, 1569, 1566, 1575, 1572, 1578, 1582, 1577, 1580],
  [1580, 1575, 1572, 1578, 1582, 1577, 1580, 1585, 1582, 1588, 1592, 1587, 1590],
];

const HomePage3 = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [marketData, setMarketData] = useState([
    { symbol: 'BTC', name: 'Bitcoin', icon: btcIcon, spark: [56623, 56700, 56650, 56720, 56680, 56690, 56660], marketCap: '$1,120,000,000,000', price: '56,623.54', change: '+1.41%' },
    { symbol: 'ETH', name: 'Ethereum', icon: ethIcon, spark: [4267, 4270, 4265, 4272, 4268, 4269, 4266], marketCap: '$520,000,000,000', price: '4,267.90', change: '+2.22%' },
    { symbol: 'BNB', name: 'Binance Coin', icon: bnbIcon, spark: [587, 588, 587.5, 588.2, 587.8, 587.9, 587.6], marketCap: '$97,000,000,000', price: '587.74', change: '+0.82%' },
    { symbol: 'USDT', name: 'Tether', icon: usdtIcon, spark: [0.998, 0.999, 1.001, 1.000, 0.999, 0.9998, 0.9998], marketCap: '$83,000,000,000', price: '0.9998', change: '+0.03%' },
    { symbol: 'SOL', name: 'Solana', icon: getCryptoIcon('SOL'), spark: [150, 151, 150.5, 151.2, 150.8, 150.9, 150.6], marketCap: '$65,000,000,000', price: '150.23', change: '+1.12%' },
    { symbol: 'XRP', name: 'XRP', icon: getCryptoIcon('XRP'), spark: [0.98, 0.99, 0.985, 0.992, 0.988, 0.989, 0.986], marketCap: '$45,000,000,000', price: '0.989', change: '-0.21%' },
    { symbol: 'DOGE', name: 'Dogecoin', icon: getCryptoIcon('DOGE'), spark: [0.15, 0.151, 0.1505, 0.1512, 0.1508, 0.1509, 0.1506], marketCap: '$22,000,000,000', price: '0.1509', change: '+0.42%' },
    { symbol: 'ADA', name: 'Cardano', icon: getCryptoIcon('ADA'), spark: [1.2, 1.21, 1.205, 1.212, 1.208, 1.209, 1.206], marketCap: '$19,000,000,000', price: '1.209', change: '-0.12%' },
    { symbol: 'TRX', name: 'TRON', icon: getCryptoIcon('TRX'), spark: [0.11, 0.112, 0.111, 0.113, 0.112, 0.111, 0.112], marketCap: '$10,000,000,000', price: '0.112', change: '+0.09%' },
    { symbol: 'TON', name: 'Toncoin', icon: getCryptoIcon('TON'), spark: [5.1, 5.12, 5.11, 5.13, 5.12, 5.11, 5.12], marketCap: '$8,000,000,000', price: '5.12', change: '+0.31%' },
  ]);
  const [isMobile, setIsMobile] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [practiceData, setPracticeData] = useState(mockChartData[0]);
  const [betResult, setBetResult] = useState(null);
  const [betPending, setBetPending] = useState(false);
  const [betMarker, setBetMarker] = useState(null);
  const chartRef = useRef();
  const chartInstanceRef = useRef();
  const [deviceAppData, setDeviceAppData] = useState([12, 14, 16, 15, 18, 19, 17]);
  const [deviceAppBalance, setDeviceAppBalance] = useState(12500);
  const [deviceAppResult, setDeviceAppResult] = useState(null);
  const [deviceAppPending, setDeviceAppPending] = useState(false);
  const [headerScrolled, setHeaderScrolled] = useState(false);
  const [parallax, setParallax] = useState(0);
  // refs для секций
  const homeRef = useRef();
  const aboutRef = useRef();
  const educationRef = useRef();
  const startRef = useRef();
  // refs для анимированных картинок
  const aboutImgRef = useRef();
  const introImgRef = useRef();
  const [isAboutVisible, setIsAboutVisible] = useState(false);
  const [isIntroVisible, setIsIntroVisible] = useState(false);
  const [shootingStars, setShootingStars] = useState([]);
  const [whiteStars, setWhiteStars] = useState([]);
  // --- TOAST NOTIFICATIONS ---
  const [toasts, setToasts] = useState([]);
  const toastId = useRef(0);
  const isMobileScreen = useMediaQuery({ maxWidth: 600 });
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    let timeout;
    function showToast() {
      const names = [
        'Alex', 'Sophia', 'Michael', 'Olivia', 'James', 'Emma', 'Daniel', 'Ava', 'William', 'Mia',
        'Benjamin', 'Charlotte', 'Lucas', 'Amelia', 'Henry', 'Harper', 'Jack', 'Ella', 'Leo', 'Lily',
      ];
      const pairs = [
        'BTC/USD', 'ETH/USD', 'BNB/USDT', 'SOL/USDT', 'XRP/USDT', 'DOGE/USDT', 'ADA/USDT', 'TON/USDT',
        'AVAX/USDT', 'LINK/USDT', 'MATIC/USDT', 'DOT/USDT', 'BCH/USDT', 'XLM/USDT', 'FIL/USDT',
      ];
      const name = names[Math.floor(Math.random() * names.length)];
      const pair = pairs[Math.floor(Math.random() * pairs.length)];
      const amount = (Math.random() * 200 + 20).toFixed(2);
      const msg = {
        id: toastId.current++,
        name,
        pair,
        amount,
      };
      setToasts((prev) => [...prev, msg]);
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== msg.id));
      }, 5000);
      timeout = setTimeout(showToast, Math.random() * 10000 + 10000); // 10-20 сек
    }
    timeout = setTimeout(showToast, Math.random() * 10000 + 10000);
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Intersection Observer для появления блоков
  useEffect(() => {
    const aboutNode = aboutImgRef.current;
    const introNode = introImgRef.current;
    if (!aboutNode && !introNode) return;
    const observer = new window.IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.target === aboutNode && entry.isIntersecting) setIsAboutVisible(true);
          if (entry.target === introNode && entry.isIntersecting) setIsIntroVisible(true);
        });
      },
      { threshold: 0.3 }
    );
    if (aboutNode) observer.observe(aboutNode);
    if (introNode) observer.observe(introNode);
    return () => {
      if (aboutNode) observer.unobserve(aboutNode);
      if (introNode) observer.unobserve(introNode);
    };
  }, []);

  useEffect(() => {
    let ticking = false;
    let lastScroll = 0;
    let lastRAF = 0;
    const onScroll = () => {
      lastScroll = window.scrollY;
      if (!ticking && !document.hidden) {
        ticking = true;
        lastRAF = window.requestAnimationFrame(() => {
          setParallax(lastScroll);
          setHeaderScrolled(lastScroll > 8);
          ticking = false;
        });
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        setParallax(window.scrollY);
        setHeaderScrolled(window.scrollY > 8);
      }
    });
    onScroll();
    return () => {
      window.removeEventListener('scroll', onScroll);
      if (lastRAF) window.cancelAnimationFrame(lastRAF);
    };
  }, []);

  useEffect(() => {
    async function fetchBinanceMarketData() {
      setLoading(true);
      try {
        const res = await fetch('https://api.binance.com/api/v3/ticker/24hr');
        const data = await res.json();
        const symbols = [
          'BTCUSDT', 'ETHUSDT', 'BNBUSDT', 'SOLUSDT', 'XRPUSDT',
          'DOGEUSDT', 'ADAUSDT', 'TRXUSDT', 'TONUSDT', 'SHIBUSDT',
          'AVAXUSDT', 'LINKUSDT', 'MATICUSDT', 'DOTUSDT', 'BCHUSDT',
          'XLMUSDT', 'FILUSDT', 'USDTUSDT'
        ];
        let filtered = data.filter(item => symbols.includes(item.symbol));
        // Для каждой монеты подгружаем историю цен (spark)
        const marketDataWithSpark = await Promise.all(filtered.map(async (item) => {
          const price = parseFloat(item.lastPrice);
          const volume = parseFloat(item.quoteVolume);
          const marketCap = price * volume;
          let spark = [];
          try {
            const klinesRes = await fetch(`https://api.binance.com/api/v3/klines?symbol=${item.symbol}&interval=1m&limit=20`);
            const klines = await klinesRes.json();
            spark = klines.map(k => parseFloat(k[4])); // k[4] — close
          } catch (e) {
            spark = [price];
          }
          return {
            symbol: item.symbol.replace('USDT',''),
            name: item.symbol.replace('USDT',''),
            icon: getCryptoIcon(item.symbol.replace('USDT','')),
            spark,
            marketCap: `$${marketCap.toLocaleString('en-US', {maximumFractionDigits:0})}`,
            price: price.toLocaleString('en-US', {maximumFractionDigits:6}),
            change: (item.priceChangePercent > 0 ? '+' : '') + parseFloat(item.priceChangePercent).toFixed(2) + '%',
          };
        }));
        // Сортируем по marketCap и берём топ-10
        const sorted = marketDataWithSpark.sort((a, b) => {
          const getCap = x => parseFloat((x.marketCap||'').replace(/[^\d.]/g, ''));
          return getCap(b) - getCap(a);
        }).slice(0, 10);
        setMarketData(sorted);
      } catch (e) {
        // fallback: не меняем marketData
      } finally {
      setLoading(false);
      }
    }
    fetchBinanceMarketData();
  }, []);

  const handlePracticeBet = (direction) => {
    if (betPending) return;
    setBetPending(true);
    const start = practiceData[practiceData.length - 1];
    setBetMarker({ index: practiceData.length - 1, direction, price: start });
    setTimeout(() => {
      const next = start + (Math.random() > 0.5 ? 8 : -8);
      const newData = [...practiceData.slice(1), next];
      setPracticeData(newData);
      const win = (direction === 'up' && next > start) || (direction === 'down' && next < start);
      setBetResult(win ? 'win' : 'lose');
      setTimeout(() => {
        setBetResult(null);
        setBetMarker(null);
      }, 1200);
      setBetPending(false);
    }, 1200);
  };

  const handleDeviceAppBet = (direction) => {
    if (deviceAppPending) return;
    setDeviceAppPending(true);
    const start = deviceAppData[deviceAppData.length - 1];
    setTimeout(() => {
      const next = start + (Math.random() > 0.5 ? 2 : -2);
      const newData = [...deviceAppData.slice(1), next];
      setDeviceAppData(newData);
      const win = (direction === 'up' && next > start) || (direction === 'down' && next < start);
      setDeviceAppResult(win ? 'win' : 'lose');
      setDeviceAppBalance(b => b + (win ? 100 : -100));
      setTimeout(() => {
        setDeviceAppResult(null);
      }, 1200);
      setDeviceAppPending(false);
    }, 1200);
  };

  const handleNavClick = (ref) => (e) => {
    e.preventDefault();
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // Координаты для статичных и мерцающих звёзд
  const flickerStars = [
    { left: '5%', top: '10%', cls: 'star-flicker-1', px: 0.18 },
    { left: '15%', top: '30%', cls: 'star-flicker-2', px: 0.22 },
    { left: '25%', top: '60%', cls: 'star-flicker-3', px: 0.28 },
    { left: '40%', top: '20%', cls: 'star-flicker-4', px: 0.13 },
    { left: '55%', top: '80%', cls: 'star-flicker-5', px: 0.32 },
    { left: '70%', top: '15%', cls: 'star-flicker-1', px: 0.19 },
    { left: '80%', top: '40%', cls: 'star-flicker-2', px: 0.25 },
    { left: '90%', top: '70%', cls: 'star-flicker-3', px: 0.31 },
    { left: '60%', top: '60%', cls: 'star-flicker-4', px: 0.21 },
    { left: '35%', top: '75%', cls: 'star-flicker-5', px: 0.17 },
    { left: '75%', top: '85%', cls: 'star-flicker-1', px: 0.29 },
    { left: '20%', top: '85%', cls: 'star-flicker-2', px: 0.23 },
    { left: '85%', top: '25%', cls: 'star-flicker-3', px: 0.15 },
    { left: '50%', top: '50%', cls: 'star-flicker-4', px: 0.27 },
    { left: '10%', top: '60%', cls: 'star-flicker-5', px: 0.11 },
    { left: '12%', top: '12%', cls: 'star-flicker-2', px: 0.16 },
    { left: '18%', top: '55%', cls: 'star-flicker-3', px: 0.24 },
    { left: '22%', top: '80%', cls: 'star-flicker-4', px: 0.18 },
    { left: '28%', top: '18%', cls: 'star-flicker-5', px: 0.13 },
    { left: '32%', top: '45%', cls: 'star-flicker-1', px: 0.21 },
    { left: '38%', top: '65%', cls: 'star-flicker-2', px: 0.19 },
    { left: '44%', top: '32%', cls: 'star-flicker-3', px: 0.14 },
    { left: '48%', top: '78%', cls: 'star-flicker-4', px: 0.22 },
    { left: '52%', top: '12%', cls: 'star-flicker-5', px: 0.17 },
    { left: '58%', top: '38%', cls: 'star-flicker-1', px: 0.13 },
    { left: '62%', top: '68%', cls: 'star-flicker-2', px: 0.27 },
    { left: '68%', top: '22%', cls: 'star-flicker-3', px: 0.18 },
    { left: '72%', top: '55%', cls: 'star-flicker-4', px: 0.15 },
    { left: '78%', top: '80%', cls: 'star-flicker-5', px: 0.23 },
    { left: '82%', top: '18%', cls: 'star-flicker-1', px: 0.19 },
    { left: '88%', top: '45%', cls: 'star-flicker-2', px: 0.12 },
    { left: '92%', top: '65%', cls: 'star-flicker-3', px: 0.21 },
    { left: '96%', top: '32%', cls: 'star-flicker-4', px: 0.16 },
    { left: '8%', top: '78%', cls: 'star-flicker-5', px: 0.13 },
    { left: '30%', top: '10%', cls: 'star-flicker-1', px: 0.18 },
    { left: '60%', top: '10%', cls: 'star-flicker-2', px: 0.22 },
    { left: '90%', top: '10%', cls: 'star-flicker-3', px: 0.15 },
    { left: '10%', top: '90%', cls: 'star-flicker-4', px: 0.19 },
    { left: '50%', top: '90%', cls: 'star-flicker-5', px: 0.14 },
  ];
  // Мелкие статичные звёзды теперь всегда видимы
  const staticStars = React.useMemo(() => Array.from({length: 24}).map((_, i) => ({
    left: `${Math.random()*100}%`,
    top: `${Math.random()*100}%`,
    size: Math.random()*1.7+0.7
  })), []);
  // Очень мелкие статичные звёзды (размер 0.3-0.7px, 60 штук)
  const verySmallStars = React.useMemo(() => Array.from({length: 32}).map((_, i) => ({
    left: `${Math.random()*100}%`,
    top: `${Math.random()*100}%`,
    size: Math.random()*0.4+0.3
  })), []);

  // --- Фиксация body при открытом меню ---
  useEffect(() => {
    if (isMobileScreen && mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isMobileScreen, mobileMenuOpen]);

  return (
    <div className={styles.root}>
      {/* Мерцающие звёзды с параллаксом */}
      {flickerStars.map((star, i) => (
        <div
          key={i}
          className={styles['star-flicker'] + ' ' + styles[star.cls]}
          style={{
            left: star.left,
            top: star.top,
          }}
        />
      ))}
      {/* Мелкие статичные звёзды без параллакса */}
      {staticStars.map((star, i) => (
        <div
          key={i}
          className={styles['star-static']}
          style={{
            left: star.left,
            top: star.top,
            width: star.size,
            height: star.size,
          }}
        />
      ))}
      {/* Очень мелкие статичные звёзды без параллакса */}
      {verySmallStars.map((star, i) => (
        <div
          key={"vs-"+i}
          className={styles['star-very-small']}
          style={{
            left: star.left,
            top: star.top,
            width: star.size,
            height: star.size,
          }}
        />
      ))}
      {/* Белые падающие звёзды — точка с хвостом */}
      {whiteStars.map(star => (
        <div
          key={star.id}
          className={styles.shootingStarDot}
          style={{
            top: `${star.top}vh`,
            left: `${star.left}vw`,
            '--dx': `${star.dx}px`,
            '--dy': `${star.dy}px`,
          }}
          aria-hidden="true"
        >
          <div className="star-dot" />
        </div>
      ))}
      <header className={styles.header + (headerScrolled ? ' ' + styles.headerScrolled : '')}>
        <div className={styles.container + ' ' + styles.headerInner}>
          <div className={styles.logoBlock}>
            <img src={logo} alt="Orbit options" className={styles.logo} />
            {/* На мобильном не показываем текст */}
            {!isMobileScreen && <span className={styles.logoTitle}>Orbit options</span>}
          </div>
          {isMobileScreen && (
            <>
              <div className={styles.headerActions} style={{marginLeft: 'auto', marginRight: 8}}>
                <button className={styles.primaryBtn} onClick={() => setShowLogin(true)}>Login</button>
              </div>
              <div className={styles.burgerMenu} onClick={() => setMobileMenuOpen(true)}>
                <svg width="32" height="32" viewBox="0 0 32 32"><rect y="7" width="32" height="3" rx="1.5" fill="#fff"/><rect y="15" width="32" height="3" rx="1.5" fill="#fff"/><rect y="23" width="32" height="3" rx="1.5" fill="#fff"/></svg>
              </div>
            </>
          )}
          {!isMobileScreen && (
            <nav className={styles.nav}>
              <a href="#home" className={styles.activeNav} onClick={handleNavClick(homeRef)}>Home</a>
              <a href="#about" onClick={handleNavClick(aboutRef)}>About</a>
              <a href="#education" onClick={handleNavClick(educationRef)}>Education</a>
              <a href="#start" onClick={handleNavClick(startRef)}>Start</a>
            </nav>
          )}
          {!isMobileScreen && (
            <div className={styles.headerActions}>
              <button className={styles.primaryBtn} onClick={() => setShowLogin(true)}>Login</button>
            </div>
          )}
        </div>
        {/* MOBILE MENU */}
        {isMobileScreen && (
          <div
            className={styles.mobileMenuOverlay + (mobileMenuOpen ? ' ' + styles.mobileMenuOpen : '')}
            onClick={() => setMobileMenuOpen(false)}
            style={{display: mobileMenuOpen ? 'block' : 'none'}}
          >
            <nav
              className={styles.mobileMenu}
              onClick={e => e.stopPropagation()}
            >
              <span className={styles.mobileMenuClose} onClick={() => setMobileMenuOpen(false)}>×</span>
              <a href="#home" onClick={e => { handleNavClick(homeRef)(e); setMobileMenuOpen(false); }}>Home</a>
              <a href="#about" onClick={e => { handleNavClick(aboutRef)(e); setMobileMenuOpen(false); }}>About</a>
              <a href="#education" onClick={e => { handleNavClick(educationRef)(e); setMobileMenuOpen(false); }}>Education</a>
              <a href="#start" onClick={e => { handleNavClick(startRef)(e); setMobileMenuOpen(false); }}>Start</a>
            </nav>
          </div>
        )}
      </header>
      <section ref={homeRef} className={styles.heroSection} style={isMobileScreen ? {marginTop: 24, marginBottom: 24} : {}}>
        <div className={styles.container}>
          <h1 className={styles.heroTitle}>
            Smart Investing Starts Here<br />Fast, Simple, Profitable!
          </h1>
          <p className={styles.heroDesc}>
            We believe financial freedom should be within reach. Our platform combines cutting-edge technology, competitive fees, and an intuitive interface—so you can invest without complexity.<br /><br />Your success is our priority!
          </p>
        </div>
      </section>
      {/* Market Trend Section */}
      <section className={styles.marketTrendSection} style={isMobileScreen ? {marginTop: 32, marginBottom: 32} : {}}>
        <div className={styles.marketTrendTitle}>Market Trend</div>
        {!isMobileScreen && (
          <div className="marketTrendArrows">
            <div className="swiper-button-prev"></div>
            <div className="swiper-button-next"></div>
          </div>
        )}
        <Swiper
          modules={[Navigation]}
          navigation={!isMobileScreen ? {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          } : false}
          spaceBetween={isMobileScreen ? 8 : 18}
          slidesPerView={isMobileScreen ? 1 : 4}
          style={{paddingBottom: 8}}
          onTouchStart={() => {
            if (isMobileScreen) {
              document.body.style.overflowX = 'hidden';
              document.documentElement.style.overflowX = 'hidden';
            }
          }}
          onTouchEnd={() => {
            if (isMobileScreen) {
              document.body.style.overflowX = '';
              document.documentElement.style.overflowX = '';
            }
          }}
        >
          {loading
            ? Array.from({length: 5}).map((_, idx) => (
                <SwiperSlide key={idx}>
                  <div className={styles.marketCard} style={{minHeight: 210, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>
                    <div className={styles.marketCardRowTop}>
                      <div className={styles.marketCardIconWrap}>
                        <Skeleton circle width={36} height={36} />
                      </div>
                      <div className={styles.marketCardLabel} style={{width: 90}}>
                        <Skeleton width={90} height={18} />
                      </div>
                      <span className={styles.marketCardGoBtn} style={{opacity: 0.5}}>
                        <Skeleton circle width={32} height={32} />
                      </span>
                    </div>
                    <div className={styles.marketCardDivider} />
                    <div className={styles.marketCardRowMain}>
                      <div className={styles.marketCardPrice}>
                        <Skeleton width={90} height={28} />
                      </div>
                      <div className={styles.marketCardSpark}>
                        <Skeleton width={90} height={36} />
                      </div>
                    </div>
                    <div className={styles.marketCardRowBottom}>
                      <Skeleton width={40} height={16} />
                    </div>
                    <div className={styles.marketCardMarketCap}>
                      <Skeleton width={120} height={14} />
                    </div>
                    <div className={styles.marketCardProfitability}>
                      <span className={styles.marketCardProfitabilityLabel}>Profitability:</span> <span className={styles.marketCardProfitabilityValue}><Skeleton width={40} height={14} /></span>
                    </div>
                  </div>
                </SwiperSlide>
              ))
            : marketData
                .slice() // копия массива
                .sort((a, b) => {
                  // Парсим marketCap в число, если возможно
                  const getCap = (item) => {
                    if (!item.marketCap) return 0;
                    const num = parseFloat(item.marketCap.replace(/[^\d.]/g, ''));
                    return isNaN(num) ? 0 : num;
                  };
                  return getCap(b) - getCap(a);
                })
                .slice(0, 10)
                .map((item, idx) => (
                <SwiperSlide key={item.symbol}>
                    <div className={styles.marketCard} onClick={() => navigate('/trade-room')} style={{cursor: 'pointer'}}>
                    <div className={styles.marketCardRowTop}>
                      <div className={
                        styles.marketCardIconWrap + ' ' +
                        (item.symbol === 'BTC' ? styles.marketCardIconBgBtc :
                         item.symbol === 'ETH' ? styles.marketCardIconBgEth :
                         item.symbol === 'BNB' ? styles.marketCardIconBgBnb :
                         item.symbol === 'USDT' ? styles.marketCardIconBgUsdt :
                         item.symbol === 'USDC' ? styles.marketCardIconBgUsdc :
                         item.symbol === 'SOL' ? styles.marketCardIconBgSol :
                           item.symbol === 'TRX' ? styles.marketCardIconBgTrx :
                           item.symbol === 'DOGE' ? styles.marketCardIconBgDoge :
                           item.symbol === 'ADA' ? styles.marketCardIconBgAda :
                           item.symbol === 'TON' ? styles.marketCardIconBgTon :
                           item.symbol === 'SHIB' ? styles.marketCardIconBgShib :
                           item.symbol === 'AVAX' ? styles.marketCardIconBgAvax :
                           item.symbol === 'LINK' ? styles.marketCardIconBgLink :
                           item.symbol === 'MATIC' ? styles.marketCardIconBgMatic :
                           item.symbol === 'DOT' ? styles.marketCardIconBgDot :
                           item.symbol === 'BCH' ? styles.marketCardIconBgBch :
                           item.symbol === 'XLM' ? styles.marketCardIconBgXlm :
                           item.symbol === 'FIL' ? styles.marketCardIconBgFil :
                         styles.marketCardIconBgDefault)
                      }>
                        <img src={item.icon} alt={item.symbol} className={styles.marketCardIcon} />
                      </div>
                      <div className={styles.marketCardLabel}>{item.name.toUpperCase()}</div>
                      <button className={styles.marketCardGoBtn} tabIndex={-1} aria-label="Go to asset">
                        <span className={styles.marketCardGoBtnCircle}>
                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M5 13L13 5M13 5H6.5M13 5V11.5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                        </span>
                      </button>
                    </div>
                    <div className={styles.marketCardDivider} />
                    <div className={styles.marketCardRowMain}>
                      <div className={styles.marketCardPrice}>${item.price}</div>
                      <div className={styles.marketCardSpark}>
                        <Line data={{labels: item.spark.map((_, i) => i + 1),datasets: [{data: item.spark,borderColor: '#00FFD1',backgroundColor: 'rgba(0,255,209,0.08)',borderWidth: 2.5,pointRadius: 0,pointHoverRadius: 0,pointBackgroundColor: '#00FFD1',fill: true,tension: 0.45,},],}} options={{responsive: false,maintainAspectRatio: false,plugins: {legend: { display: false },tooltip: { enabled: false },},scales: {x: { display: false },y: { display: false },},elements: {point: {radius: 0,hoverRadius: 0,backgroundColor: '#00FFD1',},line: {borderWidth: 2.5,borderColor: '#00FFD1',},},animation: {duration: 900,easing: 'easeInOutCubic',},hover: {mode: 'nearest',intersect: false,},}} width={90} height={36} />
                      </div>
                    </div>
                    <div className={styles.marketCardRowBottom}>
                      <span className={item.change && item.change.startsWith('+') ? styles.marketCardChangePositive : styles.marketCardChangeNegative}>{item.change}</span>
                    </div>
                    <div className={styles.marketCardMarketCap}>Market Cap: {item.marketCap}</div>
                    <div className={styles.marketCardProfitability}>
                      <span className={styles.marketCardProfitabilityLabel}>Profitability:</span> <span className={styles.marketCardProfitabilityValue}>+85%</span>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
        </Swiper>
      </section>
      {/* About Orbit Option Section */}
      <section ref={aboutRef} className={styles.aboutSection} style={isMobileScreen ? {marginTop: 24, marginBottom: 24, padding: '0 4vw'} : {}}>
        <div className={styles.aboutTextBlock + (isAboutVisible ? ' ' + styles.aboutTextBlockVisible : '')}>
          <h2 className={styles.aboutTitle}>About Orbit Option</h2>
          <ul className={styles.aboutList} style={{gap: '10px'}}>
            <li style={{whiteSpace: 'nowrap'}}>
              <span aria-label="One-Click Trading">
                <svg className={styles.aboutListIcon} width="30" height="30" viewBox="0 0 32 32" fill="none">
                  <path d="M16 4L28 16L16 28M4 16H28" stroke="#a259ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
              One-Click Trading — instant execution
            </li>
            <li style={{whiteSpace: 'nowrap'}}>
              <span aria-label="Real-Time Data">
                <svg className={styles.aboutListIcon} width="30" height="30" viewBox="0 0 32 32" fill="none">
                  <path d="M16 8V16L22 22" stroke="#a259ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M4 16H6M26 16H28M16 4V6M16 26V28" stroke="#a259ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M8 8L10 10M22 22L24 24M24 8L22 10M8 24L10 22" stroke="#a259ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
              Real-Time Data — no delays
            </li>
            <li>
              <span aria-label="Balance Protection">
                <svg className={styles.aboutListIcon} width="30" height="30" viewBox="0 0 32 32" fill="none">
                  <path d="M16 4L28 10V16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16V10L16 4Z" stroke="#a259ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M11 15L16 20L21 15" stroke="#a259ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
              Balance Protection — never go negative
            </li>
            <li>
              <span aria-label="No Hidden Fees">
                <svg className={styles.aboutListIcon} width="30" height="30" fill="none" stroke="#a259ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-5 0-9.27-3.11-11-7 1.21-2.61 3.16-4.77 5.66-6.11M1 1l22 22"></path><path d="M9.53 9.53A3.5 3.5 0 0 0 12 15.5c.96 0 1.84-.38 2.47-1M14.47 14.47A3.5 3.5 0 0 0 12 8.5c-.96 0-1.84.38-2.47 1"></path></svg>
              </span>
              No Hidden Fees — fully transparent
            </li>
            <li>
              <span aria-label="Regulated Platform">
                <svg className={styles.aboutListIcon} width="30" height="30" viewBox="0 0 32 32" fill="none">
                  <path d="M16 4L20 12.5L29 13.5L22.5 19.8L24 29L16 24.5L8 29L9.5 19.8L3 13.5L12 12.5L16 4Z" stroke="#a259ff" strokeWidth="2" strokeLinejoin="round"/>
                  <path d="M12 15L15 18L20 13" stroke="#a259ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
              Regulated Platform — licensed & compliant
            </li>
            <li>
              <span aria-label="2FA Security">
                <svg className={styles.aboutListIcon} width="30" height="30" viewBox="0 0 32 32" fill="none">
                  <path d="M8 14C8 11.7909 9.79086 10 12 10H20C22.2091 10 24 11.7909 24 14V22C24 24.2091 22.2091 26 20 26H12C9.79086 26 8 24.2091 8 22V14Z" stroke="#a259ff" strokeWidth="2"/>
                  <path d="M12 10V8C12 5.79086 13.7909 4 16 4C18.2091 4 20 5.79086 20 8V10" stroke="#a259ff" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M16 16V20" stroke="#a259ff" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </span>
              2FA Security — extra account safety
            </li>
          </ul>
          <div className={styles.aboutStatsRow} style={{gap: 48, marginTop: 32}}>
            <div className={styles.aboutStatBlock}>
              <span className={styles.aboutStatIcon}>
                <svg className={styles.aboutStatIcon} width="45" height="45" viewBox="0 0 32 32" fill="none">
                  <circle cx="16" cy="12" r="6" stroke="#a259ff" strokeWidth="2"/>
                  <path d="M27 26c0-5-4.925-9-11-9s-11 4-11 9" stroke="#a259ff" strokeWidth="2"/>
                </svg>
              </span>
              <div style={{flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center'}}>
                <div className={styles.aboutStatValue} style={{fontSize: '2.1rem', fontWeight: 700, letterSpacing: '-0.02em', marginBottom: 3, lineHeight: 1.08}}>$300K</div>
                <div className={styles.aboutStatLabel} style={{fontSize: '0.98rem', fontWeight: 400, color: '#b8b8d0', opacity: 0.92, letterSpacing: '0.01em', marginTop: 0}}>VIRTUAL ACCOUNT</div>
              </div>
            </div>
            <div className={styles.aboutStatBlock}>
              <span className={styles.aboutStatIcon}>
                <svg className={styles.aboutStatIcon} width="45" height="45" viewBox="0 0 32 32" fill="none">
                  <polyline points="6,24 12,18 18,22 26,10" stroke="#a259ff" strokeWidth="2" fill="none"/>
                  <line x1="6" y1="28" x2="6" y2="24" stroke="#a259ff" strokeWidth="2"/>
                  <line x1="12" y1="28" x2="12" y2="18" stroke="#a259ff" strokeWidth="2"/>
                  <line x1="18" y1="28" x2="18" y2="22" stroke="#a259ff" strokeWidth="2"/>
                  <line x1="26" y1="28" x2="26" y2="10" stroke="#a259ff" strokeWidth="2"/>
                </svg>
              </span>
              <div style={{flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center'}}>
                <div className={styles.aboutStatValue} style={{fontSize: '2.1rem', fontWeight: 700, letterSpacing: '-0.02em', marginBottom: 3, lineHeight: 1.08}}>195</div>
                <div className={styles.aboutStatLabel} style={{fontSize: '0.98rem', fontWeight: 400, color: '#b8b8d0', opacity: 0.92, letterSpacing: '0.01em', marginTop: 0}}>ASSETS FOR TRADING</div>
              </div>
            </div>
          </div>
        </div>
        {!isMobileScreen && (
          <div ref={aboutImgRef} className={styles.aboutImageBlock + (isAboutVisible ? ' ' + styles.aboutImageBlockVisible : '')} style={{transition:'transform 1.2s cubic-bezier(0.4,0,0.2,1), opacity 1.2s cubic-bezier(0.4,0,0.2,1)',willChange:'transform, opacity',opacity:isAboutVisible?1:0,transform:`translateX(${isAboutVisible?0:80}px) translateY(${parallax*0.03}px)`}}>
            <div className={styles.phoneMockupContainer}>
              <img 
                src={require('../images/Group 2085664277.png')} 
                alt="Trading Interface" 
                className={styles.screenContent}
              />
            </div>
        </div>
        )}
      </section>
      {/* Introducing Orbit options Section */}
      <section className={styles.introSection} style={isMobileScreen ? {marginTop: 24, marginBottom: 24, padding: '0 4vw'} : {}}>
        {!isMobileScreen && (
          <div ref={introImgRef} className={styles.introImageBlock + (isIntroVisible ? ' ' + styles.introImageBlockVisible : '')} style={{transition:'transform 1.2s cubic-bezier(0.4,0,0.2,1), opacity 1.2s cubic-bezier(0.4,0,0.2,1)',willChange:'transform, opacity',opacity:isIntroVisible?1:0,transform:`translateX(${isIntroVisible?0:-80}px) translateY(${parallax*0.03}px)`}}>
            <img src={introLaptopImg} alt="Trading chart" className={styles.introLaptopImg} />
          </div>
        )}
        <div className={styles.introTextBlock}>
          <h2 className={styles.introTitle}>Introducing Orbit options</h2>
          <div className={styles.introDesc}>
            <p>ORBIT OPTIONS delivers future-proof trading. While others impose limits, we break barriers.</p>
            <p>Join millions of investors who've already chosen us and access conditions you won't find elsewhere.</p>
            <p>With ORBIT OPTIONS, you gain more than a trading platform – you get a trusted investment partner.</p>
          </div>
          <a href="/trade-room?demo=1" className={styles.introBtn}>Start investing</a>
        </div>
      </section>
      {/* Education Section */}
      <section ref={educationRef} className={styles.educationSection} style={isMobileScreen ? {marginTop: 24, marginBottom: 24, padding: '0 4vw'} : {}}>
        <div className={styles.container}>
        <div className={styles.educationBlocks}>
          <div className={styles.educationBlockLeft}>
            <h3 className={styles.educationBlockTitle}>Your Trading Journey</h3>
            <p className={styles.educationBlockDesc}>
              We don't just provide market access — we teach profit generation.<br />
              Our education hub features:
            </p>
              <div className={styles.educationListBlocks}>
                <div className={styles.educationListItem}>
                  <span className={styles.educationListIcon} style={{background: 'rgba(162,89,255,0.18)'}}>
                    {/* Книга — фиолетовый */}
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect x="4" y="6" width="16" height="12" rx="3" fill="#a259ff"/><rect x="8" y="10" width="8" height="2" rx="1" fill="#fff"/></svg>
                  </span>
                  <span>Free tiered courses from basics to advanced algo-trading</span>
                </div>
                <div className={styles.educationListItem}>
                  <span className={styles.educationListIcon} style={{background: 'rgba(0,224,255,0.18)'}}>
                    {/* Вебинар — голубой */}
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect x="5" y="8" width="14" height="8" rx="2" fill="#00e0ff"/><rect x="9" y="12" width="6" height="2" rx="1" fill="#fff"/></svg>
                  </span>
                  <span>Daily expert webinars (20+ monthly sessions)</span>
                </div>
                <div className={styles.educationListItem}>
                  <span className={styles.educationListIcon} style={{background: 'rgba(162,89,255,0.18)'}}>
                    {/* Стратегия — фиолетовый */}
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M7 17l5-5 5 5" stroke="#a259ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><circle cx="12" cy="9" r="2" fill="#fff"/></svg>
                  </span>
                  <span>Proven strategy blueprints with backtested results</span>
                </div>
                <div className={styles.educationListItem}>
                  <span className={styles.educationListIcon} style={{background: 'rgba(0,224,255,0.18)'}}>
                    {/* AI mentor — голубой */}
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="6" fill="#00e0ff"/><rect x="9" y="10" width="6" height="2" rx="1" fill="#fff"/></svg>
                  </span>
                  <span>Dedicated onboarding AI mentor</span>
                </div>
              </div>
          </div>
          <div className={styles.educationBlockRight}>
              <div className={styles.educationCard}>
                <div className={styles.educationCardHeader}>
                  <div className={styles.educationCardIconWrap}>
                    <img src={btcIcon} alt="BTC" className={styles.educationCardIcon} />
                  </div>
                  <div className={styles.educationCardCoinInfo}>
                    <div className={styles.educationCardCoinName}>Bitcoin <span className={styles.educationCardCoinTicker}>BTC</span></div>
                    <div className={styles.educationCardAmount}>0.00080 BTC</div>
                  </div>
                  <div className={styles.educationCardPercent}>+125%</div>
                </div>
                <div className={styles.educationCardChartWrap}>
                  <Line data={{
                    labels: [1,2,3,4,5,6,7],
                    datasets: [{
                      data: [12, 14, 16, 15, 18, 19, 17],
                      borderColor: '#00FFD1',
                      backgroundColor: 'rgba(0,255,209,0.13)',
                      borderWidth: 3.5,
                      pointRadius: 0,
                      fill: true,
                      tension: 0.45,
                      shadowColor: '#00FFD1',
                      shadowBlur: 12,
                    }],
                  }} options={{
                    plugins: { legend: { display: false }, tooltip: { enabled: false } },
                    scales: { x: { display: false }, y: { display: false } },
                    elements: { point: { radius: 0 }, line: { borderWidth: 3.5 } },
                    animation: { duration: 900, easing: 'easeInOutCubic' },
                    responsive: true,
                    maintainAspectRatio: false,
                  }} height={140} />
                </div>
                <div className={styles.educationCardStatsRow}>
                  <div className={styles.educationCardStatBox + ' ' + styles.educationCardStatBoxLeft}>
                    <div className={styles.educationCardStatLabel}>Increase in Trade</div>
                    <div className={styles.educationCardStatValue}>+75% <span className={styles.educationCardStatArrow}>↑</span></div>
                    <div className={styles.educationCardStatDesc}>Sell option</div>
                  </div>
                  <div className={styles.educationCardStatBox + ' ' + styles.educationCardStatBoxRight}>
                    <div className={styles.educationCardStatValue}>$15.32</div>
                    <div className={styles.educationCardStatDesc}>Price in dollar</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Practice Confident Earnings Section */}
      <section className={styles.practiceSection}>
        <div className={styles.container + ' ' + styles.practiceContainer + ' ' + styles.practiceWide}>
          <div className={styles.practiceCardWrap}>
            <div className={styles.practiceCard + ' ' + styles.practiceCardWide}>
              <div className={styles.practiceCardHeader}>
                <span className={styles.practicePair}>USD/BTC <span className={styles.practicePairDropdown}>▼</span></span>
                <span className={styles.practicePrice}>$6278.13 <span className={styles.practicePriceChange}>+2.74%</span></span>
                <span className={styles.practiceVolume}>38.25 BTC</span>
              </div>
              <div className={styles.practiceChartWrap}>
                <Line
                  key={practiceData.join('-')}
                  ref={el => {
                    chartRef.current = el;
                    if (el && el.chartInstance) chartInstanceRef.current = el.chartInstance;
                  }}
                  data={{
                    labels: practiceData.map((_, i) => i + 1),
                    datasets: [
                      {
                        data: practiceData,
                        borderColor: '#00FFD1',
                        backgroundColor: 'rgba(0,255,209,0.13)',
                        borderWidth: 3.5,
                        pointRadius: 0,
                        fill: true,
                        tension: 0,
                        segment: {
                          borderColor: '#00FFD1',
                          borderWidth: 3.5,
                        },
                      },
                      betMarker ? {
                        data: practiceData.map((v, i) => (i === betMarker.index ? betMarker.price : null)),
                        borderColor: betMarker.direction === 'up' ? '#00FFD1' : '#ff3b81',
                        borderWidth: 0,
                        pointRadius: 7,
                        pointBackgroundColor: betMarker.direction === 'up' ? '#00FFD1' : '#ff3b81',
                        pointStyle: betMarker.direction === 'up' ? 'triangle' : 'rectRot',
                        showLine: false,
                        fill: false,
                        order: 10,
                        label: 'Bet',
                      } : null,
                    ].filter(Boolean),
                  }}
                  options={{
                    plugins: {
                      legend: { display: false },
                      tooltip: { enabled: false },
                    },
                    scales: { x: { display: false }, y: { display: false } },
                    elements: {
                      point: {
                        radius: 0,
                        backgroundColor: '#00FFD1',
                        borderWidth: 0,
                        borderColor: '#fff',
                        hoverRadius: 0,
                      },
                      line: {
                        borderWidth: 3.5,
                        borderColor: '#00FFD1',
                        borderCapStyle: 'round',
                        borderJoinStyle: 'round',
                        shadowBlur: 18,
                        shadowColor: '#00FFD1',
                      },
                    },
                    animation: { duration: 600, easing: 'linear' },
                    responsive: true,
                    maintainAspectRatio: false,
                  }}
                  height={140}
                />
                <PulseDotOnChart chartInstanceRef={chartInstanceRef} practiceData={practiceData} />
                {betResult && (
                  <div className={styles.practiceBetResult + ' ' + (betResult === 'win' ? styles.practiceBetWin : styles.practiceBetLose)}>
                    {betResult === 'win' ? 'Вы выиграли!' : 'Вы проиграли!'}
                  </div>
                )}
              </div>
              <div className={styles.practiceCardActions}>
                <button className={styles.practiceBuyBtn} disabled={betPending} onClick={() => handlePracticeBet('up')}>Buy</button>
                <button className={styles.practiceSellBtn} disabled={betPending} onClick={() => handlePracticeBet('down')}>Sell</button>
              </div>
            </div>
          </div>
          <div className={styles.practiceTextBlock + ' ' + styles.practiceTextCompact}>
            <h2 className={styles.practiceTitle}>Practice Confident<br />Earnings Risk-Free</h2>
            <div className={styles.practiceDesc}>ORBIT OPTIONS offers unparalleled skill-building tools:</div>
            <ul className={styles.practiceList}>
              <li>Trading simulator with up to $100K virtual capital</li>
              <li>Case studies of top traders' deals with expert annotations</li>
              <li>Weekly demo contests with real prize pools</li>
              <li>Backtesting automation for your personal strategies</li>
            </ul>
          </div>
        </div>
      </section>
      {/* From Beginner to Pro Section */}
      <section className={styles.proSection}>
        <div className={styles.container + ' ' + styles.proContainer}>
          <div className={styles.proTextBlock}>
            <h2 className={styles.proTitle}>From Beginner to Pro</h2>
            <div className={styles.proDesc}>Our trader development program features:</div>
            <ul className={styles.proList}>
            <li>Smart progress tracker with performance analytics</li>
              <li>Exclusive mastermind community of 7-figure traders</li>
            <li>Career opportunities with partner hedge funds</li>
            <li>Lifetime access to all updated educational content</li>
          </ul>
          </div>
          <div className={styles.proCryptoListWrap}>
            <div className={styles.proCryptoListCard}>
              <div className={styles.proCryptoListHeader}>
                <span> </span>
                <span className={styles.proCryptoListCol}>Price</span>
                <span className={styles.proCryptoListCol}>Change</span>
                <span className={styles.proCryptoListCol}>Volume (24h)</span>
              </div>
              <div className={styles.proCryptoListRow + ' ' + styles.proCryptoListRowActive}>
                <span className={styles.proCryptoIcon + ' ' + styles.proCryptoIconBtc}>
                  <img src={getCryptoIcon('BTC')} alt="BTC" style={{width: 28, height: 28, objectFit: 'contain'}} />
                </span>
                <span className={styles.proCryptoName}><b>BTC</b><br /><span>Bitcoin</span></span>
                <span className={styles.proCryptoPrice}>$6750</span>
                <span className={styles.proCryptoChange + ' ' + styles.proCryptoChangeUp}>+7.3%</span>
                <span className={styles.proCryptoVolume}>$3420214</span>
              </div>
              <div className={styles.proCryptoListRow + ' ' + styles.proCryptoListRowHighlight}>
                <span className={styles.proCryptoIcon + ' ' + styles.proCryptoIconEth}>
                  <img src={getCryptoIcon('ETH')} alt="ETH" style={{width: 28, height: 28, objectFit: 'contain'}} />
                </span>
                <span className={styles.proCryptoName}><b>ETH</b><br /><span>Ethereum</span></span>
                <span className={styles.proCryptoPrice}>$156.83</span>
                <span className={styles.proCryptoChange + ' ' + styles.proCryptoChangeDown}>-0.9%</span>
                <span className={styles.proCryptoVolume}>$1812350</span>
              </div>
              <div className={styles.proCryptoListRow}>
                <span className={styles.proCryptoIcon + ' ' + styles.proCryptoIconLtc}>
                  <img src={getCryptoIcon('LTC')} alt="LTC" style={{width: 28, height: 28, objectFit: 'contain'}} />
                </span>
                <span className={styles.proCryptoName}><b>LTC</b><br /><span>Litecoin</span></span>
                <span className={styles.proCryptoPrice}>$8535</span>
                <span className={styles.proCryptoChange + ' ' + styles.proCryptoChangeUp}>+8.2%</span>
                <span className={styles.proCryptoVolume}>$5820399</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* How To Get Started Section */}
      <section ref={startRef} className={styles.getStartedSection} style={isMobileScreen ? {marginTop: 24, marginBottom: 24, padding: '0 4vw'} : {}}>
        <div className={styles.getStartedStepperGrid}>
          {/* Картинка только на десктопе */}
          {!isMobileScreen && (
            <div className={styles.getStartedStepperImgCol}>
              <img src={require('../images/Group 2085664277.png')} alt="Get started illustration" className={styles.getStartedStepperImg} />
            </div>
          )}
          <div className={styles.getStartedStepperCol}>
        <h2 className={styles.getStartedTitle}>How To Get Started</h2>
            <div className={styles.getStartedSubtitle}>3 easy steps to become a trader</div>
            <div className={styles.getStartedStepper}>
              <div className={styles.getStartedStep}>
                <div className={styles.getStartedStepCircle}>1</div>
                <div className={styles.getStartedStepContent}>
                  <div className={styles.getStartedStepTitle}>Sign up in 1 minute</div>
                  <div className={styles.getStartedStepDesc}>Just email and password — no lengthy verification.</div>
                </div>
              </div>
              <div className={styles.getStartedStepLine}></div>
              <div className={styles.getStartedStep}>
                <div className={styles.getStartedStepCircle}>2</div>
                <div className={styles.getStartedStepContent}>
                  <div className={styles.getStartedStepTitle}>Top up your balance</div>
                  <div className={styles.getStartedStepDesc}>Start with just $1. We accept cards, crypto, e-wallets.</div>
                </div>
              </div>
              <div className={styles.getStartedStepLine}></div>
              <div className={styles.getStartedStep}>
                <div className={styles.getStartedStepCircle}>3</div>
                <div className={styles.getStartedStepContent}>
                  <div className={styles.getStartedStepTitle}>Start trading & earn</div>
                  <div className={styles.getStartedStepDesc}>Select assets, use our training, and profit today!</div>
                </div>
              </div>
            </div>
            <a href="/trade-room?demo=1" className={styles.getStartedBtn + ' ' + styles.getStartedBtnBig}>Get Started</a>
          </div>
        </div>
      </section>
      {/* Web App For Any Device Section */}
      <section className={styles.deviceAppSection} style={isMobileScreen ? {marginTop: 24, marginBottom: 24, padding: '0 4vw'} : {}}>
        <div className={styles.container}>
          <h2 className={styles.deviceAppTitle}>Web application for any device</h2>
          <div className={styles.deviceAppCards}>
            {/* macOS */}
            <a href="#" className={styles.deviceAppCard}>
              <div className={styles.deviceAppIcon}>
                <div className={styles.iconGlow}></div>
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.deviceIcon}>
                  <path d="M24.3 16.8c0-3.8 3.1-5.6 3.2-5.7-1.8-2.6-4.5-2.9-5.5-3-2.3-0.2-4.5 1.4-5.7 1.4-1.2 0-3-1.3-4.9-1.3-2.5 0-4.9 1.5-6.2 3.8-2.6 4.6-0.7 11.3 1.9 15 1.3 1.8 2.8 3.9 4.7 3.8 1.9-0.1 2.6-1.2 4.9-1.2 2.3 0 2.9 1.2 4.9 1.2 2 0 3.3-1.9 4.6-3.7 1.4-2.1 2-4.2 2.1-4.3 0 0-4-1.5-4-6z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M19.4 8.1c1-1.3 1.7-3 1.6-4.8-1.5 0.1-3.3 1-4.4 2.3-1 1.1-1.8 2.9-1.6 4.6 1.7 0.1 3.4-0.9 4.4-2.1z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className={styles.deviceAppLabel}>macOS</div>
            </a>
            {/* Android */}
            <a href="#" className={styles.deviceAppCard}>
              <div className={styles.deviceAppIcon}>
                <div className={styles.iconGlow}></div>
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.deviceIcon}>
                  <path d="M6 21.3V11c0-5.5 4.5-10 10-10s10 4.5 10 10v10.3" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M4 21.3v5c0 .6.4 1 1 1h22c.6 0 1-.4 1-1v-5M16 27v-6M9.5 13.5h13M9.5 17.3h13" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className={styles.deviceAppLabel}>Android</div>
            </a>
            {/* APK */}
            <a href="#" className={styles.deviceAppCard}>
              <div className={styles.deviceAppIcon}>
                <div className={styles.iconGlow}></div>
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.deviceIcon}>
                  <path d="M25 28H7c-.6 0-1-.4-1-1V5c0-.6.4-1 1-1h12l7 7v16c0 .6-.4 1-1 1z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M19 4v7h7M12 15h8M12 19h8M12 23h8" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className={styles.deviceAppLabel}>APK</div>
            </a>
            {/* Web App */}
            <a href="#" className={styles.deviceAppCard}>
              <div className={styles.deviceAppIcon}>
                <div className={styles.iconGlow}></div>
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.deviceIcon}>
                  <path d="M16 4a12 12 0 1 0 12 12A12 12 0 0 0 16 4z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M11 16c0 6.1 1 11 5 11s5-4.9 5-11-1-11-5-11-5 4.9-5 11z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M4 16h24M5 11h22M5 21h22" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className={styles.deviceAppLabel}>Web App</div>
            </a>
            {/* Telegram */}
            <a href="#" className={styles.deviceAppCard}>
              <div className={styles.deviceAppIcon}>
                <div className={styles.iconGlow}></div>
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.deviceIcon}>
                  <path d="M11 16.9L22.2 26.8c.6.5 1.5.1 1.6-.7l6.7-25.5c.2-.8-.6-1.5-1.3-1.2L4.2 13.6c-.9.4-.7 1.7.3 1.9l6.5 1.4z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M11 16.9l2 7.3c.2.7 1.1.9 1.6.3l3.4-6.9c.2-.5.8-.7 1.2-.3l6.6 4.9c.5.4 1.2.1 1.4-.5l6.7-25.5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className={styles.deviceAppLabel}>Telegram bot</div>
            </a>
          </div>
        </div>
      </section>
      {/* Footer */}
      <footer className={styles.footer} style={isMobileScreen ? {marginTop: 24, padding: '18px 4px 8px 4px'} : {}}>
        <div className={styles.footerContent}>
          <div className={styles.footerBrandBlock}>
            <div className={styles.footerLogo}>Orbit option</div>
            <div className={styles.footerSocials}>
              <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><svg width="32" height="32" fill="none" viewBox="0 0 32 32"><rect width="32" height="32" rx="8" fill="none"/><rect x="7" y="7" width="18" height="18" rx="6" stroke="#fff" strokeWidth="2"/><circle cx="16" cy="16" r="4.5" stroke="#fff" strokeWidth="2"/><circle cx="22.2" cy="9.8" r="1.2" fill="#fff"/></svg></a>
              <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><svg width="32" height="32" fill="none" viewBox="0 0 32 32"><rect width="32" height="32" rx="8" fill="none"/><path d="M20.5 16H18V24H15V16H13.5V13.5H15V12.25C15 10.73 15.73 9 18 9H20.5V11.5H19C18.45 11.5 18 11.95 18 12.5V13.5H20.5V16Z" fill="#fff"/></svg></a>
              <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><svg width="32" height="32" fill="none" viewBox="0 0 32 32"><rect width="32" height="32" rx="8" fill="none"/><path d="M24 12.1c-.5.2-1 .4-1.5.5.5-.3.9-.8 1.1-1.3-.5.3-1 .5-1.6.6-.5-.5-1.2-.8-2-.8-1.5 0-2.7 1.2-2.7 2.7 0 .2 0 .4.1.6-2.2-.1-4.1-1.2-5.4-2.8-.2.4-.3.8-.3 1.3 0 .9.5 1.7 1.2 2.2-.4 0-.8-.1-1.1-.3v.1c0 1.3.9 2.3 2.1 2.6-.2.1-.4.1-.7.1-.1 0-.2 0-.3-.1.2.8 1 1.4 1.9 1.4-0.7.6-1.6.9-2.5.9-.2 0-.4 0-.6-.1.9.6 2 1 3.1 1 3.7 0 5.7-3.1 5.7-5.7v-.3c.4-.3.8-.7 1.1-1.1z" fill="#fff"/></svg></a>
              <a href="#" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><svg width="32" height="32" fill="none" viewBox="0 0 32 32"><rect width="32" height="32" rx="8" fill="none"/><path d="M22.5 13.1c-.2-.7-.7-1.2-1.4-1.4C20 11.5 16 11.5 16 11.5s-4 0-5.1.2c-.7.2-1.2.7-1.4 1.4C9.3 14.2 9.3 16 9.3 16s0 1.8.2 2.9c.2.7.7 1.2 1.4 1.4C12 20.5 16 20.5 16 20.5s4 0 5.1-.2c.7-.2 1.2-.7 1.4-1.4.2-1.1.2-2.9.2-2.9s0-1.8-.2-2.9zM14.5 18.2v-4.4l4 2.2-4 2.2z" fill="#fff"/></svg></a>
            </div>
            <div className={styles.footerCopyright}>2025 All rights reserved</div>
          </div>
          <div className={styles.footerLegalBlock}>
            <div className={styles.footerLegalText}>
              The financial products offered by the company carry a high level of risk and can result in the loss of all your funds.<br />You should never invest money that you cannot afford to lose.<br /><br />
              Digital Smart LLC. Address: Lighthouse Trust Nevis Ltd, Suite 1, A.L. Evelyn Ltd Building, Main Street, Charlestown, Nevis<br />
              Payment transactions are managed by: DIGITAL SMART CY LIMITED<br />
              Address: 6 Koutsoevnti street, 4101 Agios Athanasios Limassol, Cyprus<br />
              Company business number: HE 410889
            </div>
          </div>
        </div>
      </footer>
      {/* Login Modal */}
      <Modal open={showLogin} onClose={() => setShowLogin(false)} backdrop={true} keyboard={true} size="md">
        <SignIn isModal onCloseModal={() => setShowLogin(false)} />
      </Modal>
      {/* TOAST NOTIFICATIONS */}
      <div className={styles.toastContainer + ' ' + styles.toastContainerRight}>
        {toasts.map((toast) => (
          <div key={toast.id} className={styles.toast}>
            <span className={styles.toastIcon}>
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none"><circle cx="11" cy="11" r="11" fill="#00FFD1"/><path d="M7 12.5L10 15.5L15 9.5" stroke="#23223a" strokeWidth="2.2" strokeLinecap="round"/></svg>
            </span>
            <span className={styles.toastText}>
              Trader <b>{toast.name}</b> just earned <span className={styles.toastAmount}>${toast.amount}</span> on <span className={styles.toastPair}>{toast.pair}</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

function PulseDotOnChart({ chartInstanceRef, practiceData }) {
  const [pos, setPos] = useState({ left: '100%', top: '50%' });
  useEffect(() => {
    // Ждём рендера Chart.js
    const timeout = setTimeout(() => {
      const chart = chartInstanceRef.current;
      if (!chart) return;
      const meta = chart.getDatasetMeta(0);
      if (!meta || !meta.data || !meta.data.length) return;
      // Берём последнюю точку линии
      const lastPoint = meta.data[meta.data.length - 1];
      if (!lastPoint) return;
      const { x, y } = lastPoint.getProps(['x', 'y'], true);
      setPos({ left: x, top: y });
    }, 30);
    return () => clearTimeout(timeout);
  }, [practiceData, chartInstanceRef]);
  return (
    <div className={styles.pulseDot} style={{ left: pos.left, top: pos.top, position: 'absolute', zIndex: 3, transform: 'translate(-50%, -50%)' }} />
  );
}

const deviceAppChartData = (data) => ({
  labels: data.map((_, i) => i + 1),
  datasets: [
    {
      data,
      borderColor: '#00FFD1',
      backgroundColor: 'rgba(0,255,209,0.13)',
      borderWidth: 3.5,
      pointRadius: 0,
      fill: true,
      tension: 0.45,
      shadowColor: '#00FFD1',
      shadowBlur: 12,
    },
  ],
});

const deviceAppChartOptions = {
  plugins: { legend: { display: false }, tooltip: { enabled: false } },
  scales: { x: { display: false }, y: { display: false } },
  elements: { point: { radius: 0 }, line: { borderWidth: 3.5 } },
  animation: { duration: 900, easing: 'easeInOutCubic' },
  responsive: true,
  maintainAspectRatio: false,
};

export default HomePage3; 